import request from './api';
import { getArgFromUrl } from 'utils';
import dayjs from 'dayjs';
import {
  GuildInfoType,
  MemberInfoType,
  MasterSalary,
  MemberSalary,
  MembersDetailType,
  FlowItem,
  MemberTimeItem,
  AllInviteItemType,
  newFlowItem
} from './type';

// const month = dayjs().format('YYYYMM')

export const getGuildInfo = async (): Promise<GuildInfoType | undefined> =>
  await request('GET', `/info/v1/app/getGuildInfo`);

export const searchUser = async (key: string): Promise<MemberInfoType[] | undefined> =>
  await request('POST', `/info/v1/app/searchByKey`, {
    key,
  });

export const invite = async (
  guildId: number,
  userId: string,
): Promise<MemberInfoType[] | undefined> =>
  await request('POST', `/info/v1/app/apply/${guildId}/${userId}`);

export const membersList = async (guildId: number): Promise<MemberInfoType[] | undefined> =>
  await request('GET', `/info/v1/app/getGuildMembers/${guildId}`);

export const masterSalary = async (
  guildId: number,
  date: string,
  isHalfMonth?: boolean,
): Promise<MasterSalary | undefined> =>
  await request('GET', `/salary/v2/getMasterSalary${isHalfMonth ? '/halfMonth' : ''}/${guildId}/${date}`);

export const memberSalary = async (
  guildId: number,
  date: string,
  uid: number,
  isHalfMonth?: boolean,
): Promise<MemberSalary | undefined> =>
  await request(
    'GET',
    `/salary/v2/getMasterLiveAndCoinSalary${isHalfMonth ? '/halfMonth' : ''}/${guildId}/${date}/${uid}`,
  );

export const membersDetailList = async (
  guildId: number,
  date: string,
  isHalfMonth?: boolean,
): Promise<MembersDetailType[] | undefined> =>
  await request('GET', `/salary/v2/getSalaryDetails${isHalfMonth ? '/halfMonth' : ''}/${guildId}/${date}`);

export const memberTimeList = async (
  memberId: number,
  date: string,
  guildId: number,
  isHalfMonth?: boolean,
): Promise<MemberTimeItem[] | undefined> =>
  await request(
    'GET',
    `/salary/v2/getAllByMemberId${isHalfMonth ? '/halfMonth' : ''}/${memberId}/${date}/${guildId}`,
  );

const token = getArgFromUrl('token');

const baseUrl =
  process.env.REACT_APP_ENV === 'development'
    ? 'http://192.168.0.233:9000/api/v1/guild'
    : 'https://apiv2.danachatapp.com/api/v1/guild';

export const guildData = async (
  guildId: number,
  date: string,
  uid: number,
  isHalfMonth?: boolean,
): Promise<any> =>
  await fetch(
    `${baseUrl}/salary/v2/getGuildPage${isHalfMonth ? '/halfMonth' : ''}/${guildId}/${date}/${uid}`,
    {
      headers: {
        H5Token: encodeURIComponent(`${token}`).replace(/%20/g, '%2B'),
      },
    },
  ).then((res) => res.json());

// 礼物流水配置
export const giftFlowConfig = async (
  date: string,
  isHalfMonth?: boolean,
): Promise<FlowItem[] | undefined> =>
  await request('GET', `/salary/v2/getGuildGiftFlowSalaryConfigs${isHalfMonth ? '/halfMonth' : ''}/${date}`);

// 钻石流水配置
export const coinFlowConfig = async (
  date: string,
  isHalfMonth?: boolean,
): Promise<FlowItem[] | undefined> =>
  await request('GET', `/salary/v2/getGuildCoinSalaryConfigs${isHalfMonth ? '/halfMonth' : ''}/${date}`);

export const salaryConnfig = async (
  date: string,
  isHalfMonth?: boolean,
): Promise<FlowItem[] | undefined> =>
  await request('GET', `/salary/v2/getMasterSalaryConfigByMonth${isHalfMonth ? '/halfMonth' : ''}/${date}`);

export const getAllInvite = async (): Promise<AllInviteItemType[] | undefined> =>
  await request('GET', `/info/v1/app/getAllInvite`);

export const agree = async (guildId: number): Promise<any> =>
  await request('POST', `/info/v1/app/agree/${guildId}`);

export const reject = async (guildId: number): Promise<any> =>
  await request('POST', `/info/v1/app/rejectApply/${guildId}`);

export const getFans = async (): Promise<MemberInfoType[] | undefined> =>
  await request('POST', `/info/v1/app/getFans`);

export const isMaster = async (uid: number): Promise<any> =>
  await request('GET', `/anchor/is-anchor?uid=${uid}`);


export type DayCoinRewardType = {
  "id": number,
  "guildDay": number,
  "userId": string,
  "giftFlowTotal": number,
  "reward": number,
  "createTime": number
}

export const getDayCoinReward = async (uid: number, start: number, end: number): Promise<DayCoinRewardType[] | undefined> =>
  await request('GET', `/info/getDayCoinReward?uid=${uid}&start=${start}&end=${end}`);


export const getNewConfig = async (
  date: string
): Promise<newFlowItem[] | undefined> =>
  await request<newFlowItem[]>('GET', `/salary/v2/getGuildMemberGiftFlowCoinConfigs/halfMonth/${date}`);

export const getNewConfigByMonth = async (
  month: number
): Promise<newFlowItem[] | undefined> =>
  await request<newFlowItem[]>('GET', `/salary/v2/getGuildMemberGiftFlowCoinConfigs/${month}`);